import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Modal from 'antd/lib/modal';
import Select from 'antd/lib/select';
import Typography from 'antd/lib/typography';
import { PjmMeterEquipmentStatus, PjmMeterType } from 'src/domain/pjm/dto/enums';
import { PjmLocationMeterInfo } from 'src/domain/pjm/dto/PjmLocationMeterInfo';
import { METER_TYPE } from 'src/domain/pjm/values';

interface LocationMeterModalProps {
    value?: PjmLocationMeterInfo;
    onClose: (actionTaken: boolean) => void;
    onChange: (data: PjmLocationMeterInfo) => void;
}

export function LocationMeterModal({ value, onClose, onChange }: LocationMeterModalProps) {
    const [form] = Form.useForm<any>();

    const isNew = !value;

    if (isNew) {
        value = {
            meterType: PjmMeterType.EDC_METER,
            meterStatus: PjmMeterEquipmentStatus.PENDING,
        };
    }

    const meterTypeOptions = METER_TYPE.map(it => {
        // we do not support CSP meter types right now
        return { label: it, value: it, disabled: it === 'CSP_METER' };
    });

    const meterStatusOptions = Object.values(PjmMeterEquipmentStatus).map(it => {
        return { label: it, value: it };
    });

    function onFormFinish(data: PjmLocationMeterInfo) {
        onChange(data);
    }

    return (
        <Modal
            title={isNew ? 'Add Meter' : 'Edit Meter'}
            className="pjm-location-meter-modal"
            open
            destroyOnHidden
            maskClosable={false}
            keyboard={false}
            onCancel={() => onClose(false)}
            width="500px"
            footer={[
                <Button key="pjm-location-meter-modal-cancel" onClick={() => onClose(false)}>
                    Cancel
                </Button>,
                <Button key="pjm-location-meter-modal-submit" type="primary" onClick={form.submit}>
                    Save
                </Button>,
            ]}
        >
            <Form form={form} name="pjm-location-meter-form" preserve={false} layout="vertical" onFinish={onFormFinish} initialValues={value}>
                <Form.Item name={['meterType']} label={<Typography.Text strong>Meter Type</Typography.Text>}>
                    <Select showSearch autoClearSearchValue optionFilterProp="label" placeholder="Select Meter Type" options={meterTypeOptions} />
                </Form.Item>
                {isNew && (
                    <Form.Item name={['meterStatus']} label={<Typography.Text strong>Meter Status</Typography.Text>} hidden>
                        <Select
                            disabled
                            showSearch
                            autoClearSearchValue
                            optionFilterProp="label"
                            placeholder="Select Meter Status"
                            options={meterStatusOptions}
                        />
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
}
